import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Button, Group } from "@mantine/core";
import { useContext } from "react";
import { FormattedMessage } from "react-intl";
import { StyleEditorContext } from "../../components/StyleEditorContext.js";
export const SystemMessage = ({ content, code, messageId }) => {
    const { mapkaAccountName } = useContext(StyleEditorContext);
    const handleClick = () => {
        location.replace(`/${mapkaAccountName}/admin/billing?tab=payments`);
    };
    const renderContent = () => {
        if (!code) {
            return content.map(({ text }, i) => _jsx("span", { children: text }, i));
        }
        switch (code) {
            case "AboveLimitError":
                return (_jsxs(_Fragment, { children: [_jsx(FormattedMessage, { defaultMessage: "You have reached the maximum number of free tokens", id: "error.aboveLimitAIAssistant" }), _jsx(Button, { variant: "tertiary", ml: "sm", size: "xs", onClick: handleClick, children: _jsx(FormattedMessage, { defaultMessage: "Add payment", id: "message.addPayment" }) })] }));
            case "AnthropicOverloaded":
                return (_jsx(FormattedMessage, { defaultMessage: "Anthropic's API is currently overloaded. Mapka tried alternate models but all are busy. Please try again in a moment.", id: "error.anthropicOverloaded" }));
        }
        return null;
    };
    return (_jsx(Group, { justify: "left", m: "xs", "data-list-item": true, "data-message-id": messageId, children: _jsx(Alert, { variant: "filled", color: "red", p: "xs", children: renderContent() }) }));
};
